// extracted by mini-css-extract-plugin
export default {"greetings":"Greetings_greetings__6XaZo","information":"Greetings_information__zqsYj"};